import React, { useState } from "react";
import "./Inner_Calm_Banner.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faShare,
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import Introduction_Modal from "../../common/modals/introduction_modal/Introduction_Modal";
import Music_play_modal from "../../common/modals/music-play-modal/Music_play_modal";
import { IDS } from "../../../utils/IDS";

const Inner_Calm_Banner = ({ image, name, time, desc, video, music }) => {

  const [showModal, setShowModal] = useState(false)
  const [modalShow2, setModalShow2] = useState(false)

  return (
    <section className="Inner_Calm_Banner">
      <div className="container">
        <div className="content_div">
          <div className="banner_img_holder">
            <img
              src={IDS.IMG_URL + image}
              className="banner_img"
            />
          </div>

          <div className="meditation_content_div">
            <div className="top_div">
              <p className="title_text">{name}</p>
              <div className="gray_div">
                <p className="time">{time}</p>
              </div>

              <div
                className="share_icon_div"
                onClick={() => {
                  if (navigator.share) {
                    navigator.share({
                      title: document.title,
                      url: window.location.href,
                    });
                  } else {
                    // Fallback: copy link
                    navigator.clipboard.writeText(window.location.href);
                    alert("Link copied to clipboard");
                  }
                }}
              >
                <FontAwesomeIcon icon={faShareNodes} className="share_icon" />
              </div>

            </div>

            <p className="descn_text">{desc}
            </p>
          </div>

          <div className="footer_div">
            <div className="intro_btn_div zoom_in_out" onClick={() => { setShowModal(true) }}>
              <p className="btn_text">
                <FontAwesomeIcon icon={faYoutube} className="yt_icon" />
                Introduction
              </p>
            </div>

            <div className="practice_btn_div zoom_in_out" onClick={() => { setModalShow2(true) }}>
              <p className="play_text">
                <FontAwesomeIcon icon={faPlay} className="practice_icon" />
                Practice Now
              </p>
            </div>
          </div>
        </div>
      </div>

      <Introduction_Modal
        video={video}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />

      <Music_play_modal
        music={{ audio: music, name }}
        show={modalShow2}
        onHide={() => setModalShow2(false)}
      />
    </section>
  );
};

export default Inner_Calm_Banner;
